import { render, staticRenderFns } from "./HistoryDatasetLink.vue?vue&type=template&id=04556f74&"
import script from "./HistoryDatasetLink.vue?vue&type=script&lang=js&"
export * from "./HistoryDatasetLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports